import { Box, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export interface IndividualLessonTime {
  day: string;
  time: string;
}

export interface IndividualLesson {
  title: string;
  time: IndividualLessonTime[];
}

export interface ScheduleType {
  title: string;
  subTitle: string;
  time: string;
}

export interface ScheduleDay {
  day: string;
  classes: ScheduleType[];
}

// Programma ufficiale della stagione 2026/2027.
export const schedule: ScheduleDay[] = [
  {
    day: 'days.monday',
    classes: [
      { title: 'schedule.classicBallet', subTitle: 'schedule.ages24', time: '17:00 - 17:50' },
      { title: 'schedule.classicBallet', subTitle: 'schedule.ages58beginners', time: '18:00 - 18:55' },
      { title: 'schedule.modernBallet', subTitle: 'schedule.ages9', time: '19:00 - 20:00' },
    ],
  },
  {
    day: 'days.tuesday',
    classes: [
      { title: 'schedule.classicBallet', subTitle: 'schedule.ages58advanced', time: '18:00 - 19:00' },
      { title: 'schedule.classicBallet', subTitle: 'schedule.ages9', time: '19:00 - 20:00' },
    ],
  },
  {
    day: 'days.wednesday',
    classes: [
      { title: 'schedule.modernBallet', subTitle: 'schedule.ages58', time: '17:45 - 18:40' },
      { title: 'schedule.modernBallet', subTitle: 'schedule.ages9', time: '18:45 - 19:45' },
      { title: 'schedule.stretching', subTitle: 'schedule.adults', time: '19:45 - 20:45' },
    ],
  },
  {
    day: 'days.thursday',
    classes: [
      { title: 'schedule.classicBallet', subTitle: 'schedule.ages24', time: '17:00 - 17:50' },
      { title: 'schedule.classicBallet', subTitle: 'schedule.ages58beginners', time: '18:00 - 18:55' },
      { title: 'schedule.classicBallet', subTitle: 'schedule.ages58advanced', time: '19:00 - 20:00' },
    ],
  },
  {
    day: 'days.friday',
    classes: [
      { title: 'schedule.modernBallet', subTitle: 'schedule.ages58', time: '18:00 - 18:55' },
      { title: 'schedule.classicBallet', subTitle: 'schedule.ages9', time: '19:00 - 20:00' },
    ],
  },
]

export const getSchedule = (lessonName: string): IndividualLesson[] => {
  return schedule.reduce<IndividualLesson[]>((lessons, day) => {
    day.classes
      .filter((lesson) => lesson.title === lessonName)
      .forEach((lesson) => {
        const existingLesson = lessons.find((item) => item.title === lesson.subTitle)
        const lessonTime = { day: day.day, time: lesson.time }

        if (existingLesson) {
          existingLesson.time.push(lessonTime)
        } else {
          lessons.push({ title: lesson.subTitle, time: [lessonTime] })
        }
      })

    return lessons
  }, [])
}

const TableTitle = ({ title }: { title: string }) => {
  const { t } = useTranslation()

  return (
  <Box
    textAlign="center"
    fontWeight="bold"
    fontFamily="heading"
    fontSize={{ base: 'lg', md: 'xl' }}
    color="purple.900"
    p={2}
  >
    {t(title)}
  </Box>
  )
}

const TableElement = ({ title, subTitle, time }: ScheduleType) => {
  const { t } = useTranslation()

  return (
  <Box
    bg="rgba(255,255,255,0.8)"
    textAlign="center"
    borderRadius="10px"
    width="100%"
    border="1px solid"
    borderColor="purple.100"
    boxShadow="sm"
    p={{ base: 3, md: 2 }}
  >
    <Text fontWeight="bold" fontSize="md" color="purple.900">
      {t(title)}
    </Text>
    <Text fontSize="sm" lineHeight="short" minHeight={{ base: 'auto', md: '2.5em' }}>
      ({t(subTitle)})
    </Text>
    <Text fontSize="sm" fontWeight="medium" color="gray.700">
      {time}
    </Text>
  </Box>
  )
}

const ScheduleTable = () => {
  return (
    <SimpleGrid
    bg="rgba(255,255,255,0.45)"
    gap={{ base: 4, md: 3 }}
    borderRadius="16px"
    width="100%"
    padding={{ base: 4, md: 6 }}
    columns={{ base: 1, md: 2, xl: 5 }}
  >
    {schedule.map((day) => (
      <VStack key={day.day} align="stretch" spacing={2}>
        <TableTitle title={day.day} />
        {day.classes.map((lesson) => (
          <TableElement key={`${day.day}-${lesson.title}-${lesson.subTitle}`} {...lesson} />
        ))}
      </VStack>
    ))}
    </SimpleGrid>
  )
}

export default ScheduleTable
